import { FormattedMessage } from 'react-intl';

import Drawer from 'components/base/Drawer';

import * as S from './style';

import { DrawerCriticalityQualifiersProps } from './types';

const DrawerCriticalityQualifiers: React.FC<DrawerCriticalityQualifiersProps> =
  ({ openDrawer, onCloseDrawer }) => {
    return (
      <Drawer openDrawer={openDrawer} onCloseDrawer={onCloseDrawer}>
        <S.DrawerContentTitle data-testid="DrawerContentTitle">
          <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.TITLE" />
        </S.DrawerContentTitle>

        <S.DrawerContentSubTitle>
          <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.SUBTITLE" />
        </S.DrawerContentSubTitle>

        <S.DrawerContainerBox>
          <S.DrawerContentBox>
            <S.DrawerContentBoxTitle>
              <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.SERIOUSRISK.TITLE" />
            </S.DrawerContentBoxTitle>

            <S.DrawerContentBoxListOl>
              <S.DrawerContentBoxListLi marker="auto">
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.1" />
                <S.DrawerContentBoxListOl>
                  <S.DrawerContentBoxListLi marker="lower-alpha">
                    <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.a" />
                  </S.DrawerContentBoxListLi>
                  <S.DrawerContentBoxListLi marker="lower-alpha">
                    <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.b" />
                  </S.DrawerContentBoxListLi>
                </S.DrawerContentBoxListOl>
              </S.DrawerContentBoxListLi>
              <S.DrawerContentBoxListLi marker="auto">
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.2" />
              </S.DrawerContentBoxListLi>
              <S.DrawerContentBoxListLi marker="auto">
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.3" />
              </S.DrawerContentBoxListLi>
            </S.DrawerContentBoxListOl>
          </S.DrawerContentBox>

          <S.DrawerContentBox>
            <S.DrawerContentBoxTitle>
              <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.HIGHRISK.TITLE" />
            </S.DrawerContentBoxTitle>

            <S.DrawerContentBoxListOl>
              <S.DrawerContentBoxListLi marker="auto">
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.HIGHRISK.LI.1" />
              </S.DrawerContentBoxListLi>

              <S.DrawerContentBoxListLi marker="auto">
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.HIGHRISK.LI.2" />
              </S.DrawerContentBoxListLi>

              <S.DrawerContentBoxListLi marker="auto">
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.HIGHRISK.LI.3" />
              </S.DrawerContentBoxListLi>
            </S.DrawerContentBoxListOl>
          </S.DrawerContentBox>

          <S.DrawerBoxFooter>
            <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.BOX.FOOTER" />
          </S.DrawerBoxFooter>
        </S.DrawerContainerBox>
      </Drawer>
    );
  };

export default DrawerCriticalityQualifiers;
